<template>
  <div>
    <v-card class="px-2">
      <v-toolbar dense color="primary" dark align="center">
        <v-row class="mt-2">
          <v-col cols="4" align="left">
            <v-toolbar-title>Gestione Interfacce Macchina</v-toolbar-title>
          </v-col>
          <v-col cols="1">
            <v-switch
              prepend-icon="mdi-bug"
              v-model="machine_configuration.debug"
              :true-value="1"
              :false-value="0"
            ></v-switch>
          </v-col>
          <v-col cols="1">
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  v-bind="attrs"
                  v-on="on"
                  light
                  :disabled="machine_configuration.interfaces == null"
                  @click="setMachineConfiguration"
                >
                  <v-icon color="success">mdi-floppy</v-icon>
                </v-btn>
              </template>
              <span>Salva configurazione</span>
            </v-tooltip>
          </v-col>
          <v-col cols="1">
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  v-bind="attrs"
                  v-on="on"
                  light
                  :disabled="machine_configuration.interfaces == null"
                  @click="addInterface"
                >
                  <v-icon color="primary">mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>Nuova interfaccia</span>
            </v-tooltip>
          </v-col>
          <v-col cols="2" align="right">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  light
                  @click="
                    $refs.nmap_dialog.apriDialog(
                      machine_configuration.gateway_id
                    )
                  "
                >
                  <v-icon color="indigo darken-1">mdi-lan</v-icon>
                </v-btn>
              </template>
              <span>Scansione di rete</span>
            </v-tooltip>
          </v-col>
          <v-col cols="1" align="right">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  light
                  @click="openPingDialog()"
                >
                  <v-icon color="indigo darken-1">mdi-cube-send</v-icon>
                </v-btn>
              </template>
              <span>Ping</span>
            </v-tooltip>
          </v-col>
          <v-col cols="1" align="right">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  light
                  @click="machine_configuration.interfaces = new Array()"
                >
                  <v-icon color="indigo darken-1">mdi-broom</v-icon>
                </v-btn>
              </template>
              <span>Reset configurazione</span>
            </v-tooltip>
          </v-col>
          <v-col cols="1" align="right">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" small light @click="refresh">
                  <v-icon color="primary">mdi-autorenew</v-icon>
                </v-btn>
              </template>
              <span>Aggiorna</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-toolbar>
      <v-container>
        <v-row>
          <v-col cols="4" class="mt-5">
            <v-select
              solo
              v-model="machine_configuration.gateway_id"
              :items="gateways"
              label="Gateway"
              item-text="device_name"
              item-value="device_id"
            />
          </v-col>
          <v-col cols="8" class="mt-5">
            <v-text-field
              v-model="machine_notes"
              label="Note macchina"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center" v-if="schema != null">
          <v-col cols="12">
            <v-expansion-panels v-if="machine_configuration.interfaces != null">
              <!-- Interface Header -->
              <v-expansion-panel
                v-for="(interf, i) in machine_configuration.interfaces"
                :key="i"
              >
                <v-expansion-panel-header>
                  <v-row no-gutters align="center">
                    <v-col cols="3">{{
                      interf.interface_name == null ||
                      interf.interface_name == ""
                        ? "Interfaccia #" + (i + 1)
                        : interf.interface_name
                    }}</v-col>
                    <v-col cols="3">
                      <v-checkbox
                        label="connessione testato"
                        readonly
                        v-model="interf.connection_tested"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="1">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            small
                            light
                            :disabled="
                              interf.module_id == null ||
                              interf.configurable != true
                            "
                            @click.stop="aggiornaConfigurazione()"
                          >
                            <v-icon color="blue">mdi-progress-upload</v-icon>
                          </v-btn>
                        </template>
                        <span>Carica Configurazione</span>
                      </v-tooltip>
                    </v-col>
                    <v-col cols="1">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            small
                            light
                            :disabled="
                              interf.module_id == null ||
                              interf.configurable != true
                            "
                            @click.stop="openDialogStrumentiDiagnostica(interf)"
                          >
                            <v-icon color="blue">mdi-list-status</v-icon>
                          </v-btn>
                        </template>
                        <span>Strumenti di diagnostica</span>
                      </v-tooltip>
                    </v-col>
                    <v-col cols="1">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            small
                            light
                            :color="
                              interface_connection_status ? 'success' : 'error'
                            "
                            :disabled="
                              interf.module_id == null ||
                              interf.configurable != true
                            "
                            @click.stop="CheckInterfaceConnectionStatus(interf)"
                          >
                            <v-icon color="white">mdi-connection</v-icon>
                          </v-btn>
                        </template>
                        <span>Controllo connessione </span>
                      </v-tooltip>
                    </v-col>
                    <v-col cols="1">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            small
                            light
                            :disabled="
                              interf.module_id == null ||
                              interf.configurable != true
                            "
                            @click.stop="$refs.register_dialog.open(interf)"
                          >
                            <v-icon color="teal"
                              >mdi-file-table-box-outline</v-icon
                            >
                          </v-btn>
                        </template>
                        <span>Registri, variabili e allarmi</span>
                      </v-tooltip>
                    </v-col>
                    <v-col cols="1">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            small
                            light
                            @click.stop="$refs.upload_dialog.open(interf)"
                            :disabled="
                              interf.module_id == null ||
                              interf.configurable != true
                            "
                          >
                            <v-icon color="indigo">mdi-table-arrow-up</v-icon>
                          </v-btn>
                        </template>
                        <span>Template di upload</span>
                      </v-tooltip>
                    </v-col>
                    <v-col cols="1">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            small
                            light
                            @click="deleteInterface(interf)"
                          >
                            <v-icon color="error">mdi-delete</v-icon>
                          </v-btn>
                        </template>
                        <span>Elimina interfaccia</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-expansion-panel-header>
                <!-- Interface Content -->
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="3">
                      <v-select
                        @change="changeModule($event, interf)"
                        v-model="interf.module_id"
                        :items="schema.modules"
                        label="Modulo di interfaccia"
                        item-text="nome"
                        item-value="id_modulo"
                      />
                    </v-col>
                    <v-col
                      cols="3"
                      v-for="(default_field, j) in schema.default_fields
                        .interface_fields"
                      :key="j"
                    >
                      <DynamicInput
                        :items="default_field.values"
                        :type="default_field.type"
                        :label="default_field.name"
                        v-model="interf[default_field.field]"
                      />
                    </v-col>
                    <template v-if="interf.module_id != null">
                      <v-col
                        cols="3"
                        v-for="(interface_field, k) in findModuleById(
                          interf.module_id
                        ).interface_fields"
                        :key="'specific_' + k"
                      >
                        <DynamicInput
                          :items="interface_field.values"
                          :type="interface_field.type"
                          :label="interface_field.name"
                          v-model="interf[interface_field.field]"
                        />
                      </v-col>
                    </template>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <DialogRegistriMacchina
      ref="register_dialog"
      :schema="schema"
      :machine_id="Number(id_macchina)"
      :gateway_id="Number(machine_configuration.gateway_id)"
    />
    <DialogUploadTemplate
      ref="upload_dialog"
      :schema="schema"
      :machine_id="id_macchina"
    />
    <DialogPingMacchina ref="ping_dialog" />
    <DialogScansioneRete ref="nmap_dialog" />
    <DialogTestRegistri ref="test_registri_dialog" />
    <DialogStrumentiDiagnostica ref="strumenti_diagnostica_dialog" />
    <v-snackbar v-model="ui.snackbar" color="success"
      >Salvataggio eseguito con successo</v-snackbar
    >
    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>
<script>
import DynamicInput from "../.common/DynamicInput.vue";
import DialogRegistriMacchina from "./DialogRegistriMacchina.vue";
import DialogUploadTemplate from "./DialogUploadTemplate.vue";
import DialogPingMacchina from "./DialogPingMacchina.vue";
import DialogScansioneRete from "./DialogScansioneRete.vue";
import DialogTestRegistri from "./DialogTestRegistri.vue";
import DialogStrumentiDiagnostica from "./DialogStrumentiDiagnostica.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "GestioneInterfacceMacchina",
  props: {
    id_macchina: [String, Number],
  },
  components: {
    DynamicInput,
    DialogRegistriMacchina,
    DialogUploadTemplate,
    DialogPingMacchina,
    DialogTestRegistri,
    DialogStrumentiDiagnostica,
    DialogScansioneRete,
    SnackbarQV,
  },
  data() {
    return {
      interface_connection_status: null,
      gateways: new Array(),
      machine_notes: "",
      machine_configuration: {
        debug: 1,
        gateway_id: null,
        interfaces: null,
      },
      NETWORK: null,
      schema: null,
      ui: {
        enable_config: false,
        snackbar: false,
      },
      uid_counter: 0,
    };
  },
  mounted() {
    this.NETWORK = this.$store.state.Network;
    this.getMachineNotes();
    this.refresh();
  },
  methods: {
    async aggiornaConfigurazione() {
      var connection_tested = 1;
      var registers_tested = 1;
      this.machine_configuration.interfaces.forEach((e) => {
        if (e.connection_tested == false) {
          connection_tested = 0;
        }
        e.registers((e2) => {
          if (e2.tested == false) {
            registers_tested = 0;
          }
        });
      });

      const that = this;

      const request2 = {
        controller: "quickconnext",
        endpoint: "connext",
        response: { parse: false },
        showdialog: false,
        body: {
          action: "updatedeviceconfig",
          token: localStorage.user_token,
          device_id: this.machine_configuration.gateway_id,
        },
        method: "PUT",
        on: {
          load: function () {
            that.$refs.SnackbarQV.print("success", "Configurazione Aggiornato");
          },
          error: function (response) {
            that.$refs.SnackbarQV.print("error", response);
          },
        },
      };

      const request = {
        controller: "quickconnext",
        endpoint: "connext",
        response: { parse: false },
        body: {
          action: "setmachineconfiguration",
          token: localStorage.user_token,
          conf_4_0: btoa(
            unescape(
              encodeURIComponent(
                JSON.stringify(this.machine_configuration.interfaces)
              )
            )
          ),
          id_gateway: this.machine_configuration.gateway_id,
          debug: this.machine_configuration.debug,
          machine_id: this.id_macchina,
          connection_tested_4_0: connection_tested,
          registers_tested_4_0: registers_tested,
        },
        method: "PUT",
        on: {
          load: function () {
            that.NETWORK.AjaxRequest(request2);
          },
        },
      };

      this.NETWORK.AjaxRequest(request);
    },
    //#region Common
    addDefaultFields(item, type) {
      const default_src = this.schema.default_fields[type];
      if (type == undefined) {
        return;
      }
      for (let i = 0; i < default_src.length; i++) {
        const default_item = default_src[i];
        item[default_item.field] = default_item.default_value;
      }
    },
    changeModule(module_id, interf) {
      while (interf.upload_templates.length > 0) {
        interf.upload_templates.splice(0, 1);
      }
      while (interf.registers.length > 0) {
        interf.registers.splice(0, 1);
      }
      const reserved = [
        "module_id",
        "registers",
        "upload_templates",
        "interface_id",
      ];
      for (
        let i = 0;
        i < this.schema.default_fields.interface_fields.length;
        i++
      ) {
        reserved.push(this.schema.default_fields.interface_fields[i].field);
      }
      const keys = Object.keys(interf);
      for (let i = 0; i < keys.length; i++) {
        if (reserved.indexOf(keys[i]) < 0) {
          delete interf[keys[i]];
        }
      }
      const module = this.findModuleById(module_id);
      if (module != null) {
        interf.configurable = module.configurabile == 1;
        for (let i = 0; i < module.interface_fields.length; i++) {
          const interface_field = module.interface_fields[i];
          interf[interface_field.field] = interface_field.default_value;
        }
      }
    },
    findModuleById(id) {
      const modules = this.schema.modules;
      for (let i = 0; i < modules.length; i++) {
        const module = modules[i];
        if (module.id_modulo == id) {
          return module;
        }
      }
      return null;
    },
    setConfigurableFlag() {
      const interfaces = this.machine_configuration.interfaces;
      for (let i = 0; i < interfaces.length; i++) {
        const interf = interfaces[i];
        const module = this.findModuleById(interf.module_id);
        if (module == null) {
          interfaces.module_id = null;
        } else {
          interf.configurable = module.configurabile == 1;
          interf.register_test = module.register_test == 1;
        }
      }
    },
    //#endregion

    //#region Interface
    CheckInterfaceConnectionStatus(interf) {
      let that = this;
      const request = {
        showdialog: false,
        controller: "quickconnext",
        endpoint: "connext",
        response: { parse: false },
        body: {
          action: "checkinterfaceconnectionstatus",
          token: localStorage.user_token,
          id_dispositivo: that.machine_configuration.gateway_id,
          machine_id: parseInt(that.id_macchina),
          interface_id: interf.interface_id,
        },
        method: "PUT",
        on: {
          load: function (response) {
            that.interface_connection_status = true;
            that.$refs.SnackbarQV.print("success", response);
            interf.connection_tested = true;
          },
          error: function (err) {
            that.interface_connection_status = false;
            that.$refs.SnackbarQV.print("error", err.srcElement.responseText);
            interf.connection_tested = false;
          },
        },
      };
      this.NETWORK.AjaxRequest(request);
    },

    addInterface() {
      const interf = {
        connection_tested: false,
        module_id: null,
        registers: new Array(),
        upload_templates: new Array(),
        configurable: false,
        interface_id: ++this.uid_counter,
      };
      this.addDefaultFields(interf, "interface_fields");
      this.machine_configuration.interfaces.push(interf);
    },
    deleteInterface(interf) {
      const index = this.machine_configuration.interfaces.indexOf(interf);
      if (index >= 0) {
        this.machine_configuration.interfaces.splice(index, 1);
      }
    },
    //#endregion

    //#region Get
    getConfigurationSchema() {
      const that = this;
      this.schema = null;
      const request = {
        controller: "quickconnext",
        endpoint: "connext",
        response: { parse: false },
        body: {
          action: "getconfigschema",
          token: localStorage.user_token,
        },
        method: "POST",
        on: {
          load: function (response) {
            that.schema = JSON.parse(response);
            if (that.machine_configuration.interfaces != null) {
              that.setConfigurableFlag();
            }
          },
        },
      };
      this.NETWORK.AjaxRequest(request);
    },
    getCustomerDevices() {
      const that = this;
      while (this.gateways.length > 0) {
        this.gateways.splice(0, 1);
      }
      const request = {
        controller: "quickconnext",
        endpoint: "connext",
        response: { parse: false },
        body: {
          action: "getcustomerdevices",
          token: localStorage.user_token,
        },
        method: "POST",
        on: {
          load: function (response) {
            that.gateways = JSON.parse(response);
          },
        },
      };
      this.NETWORK.AjaxRequest(request);
    },
    getMachineConfiguration() {
      const that = this;
      this.uid_counter = 0;
      Object.assign(this.machine_configuration, {
        debug: 1,
        gateway_id: null,
        interfaces: null,
      });
      const request = {
        controller: "quickconnext",
        endpoint: "connext",
        response: { parse: false },
        body: {
          action: "getmachineconfiguration",
          token: localStorage.user_token,
          machine_id: this.id_macchina,
        },
        method: "POST",
        on: {
          load: function (response) {
            response = JSON.parse(response)[0];
            that.machine_configuration.gateway_id = response.id_gateway;
            that.machine_configuration.debug = response.debug;
            try {
              that.machine_configuration.interfaces = JSON.parse(
                decodeURIComponent(escape(atob(response.conf_4_0)))
              );
              const interfaces = that.machine_configuration.interfaces;
              for (let i = 0; i < interfaces.length; i++) {
                that.uid_counter = Math.max(
                  interfaces[i].interface_id,
                  that.uid_counter
                );
              }
              if (that.schema != null) {
                that.setConfigurableFlag();
              }
            } catch {
              that.machine_configuration.interfaces = new Array();
            }
          },
        },
      };
      this.NETWORK.AjaxRequest(request);
    },
    refresh() {
      this.getCustomerDevices();
      this.getMachineConfiguration();
      this.getConfigurationSchema();
    },
    getMachineNotes() {
      const that = this;
      const request = {
        controller: "quickconnext",
        endpoint: "connext",
        response: { parse: false },
        body: {
          action: "getmachinenotes",
          token: localStorage.user_token,
          id_macchina: this.id_macchina,
        },
        method: "POST",
        on: {
          load: function (response) {
            const parsedResponse = JSON.parse(response);
            if (parsedResponse.length > 0 && parsedResponse[0].notes) {
              that.machine_notes = parsedResponse[0].notes;
            } else {
              that.machine_notes = "";
            }
          },
        },
      };
      this.NETWORK.AjaxRequest(request);
    },
    //#endregion

    //#region Set
    setMachineConfiguration() {
      var connection_tested = 1;
      var registers_tested = 1;
      try {
        this.machine_configuration.interfaces.forEach((e) => {
          if (e.connection_tested == false) {
            connection_tested = 0;
          }
          e.registers((e2) => {
            if (e2.tested == false) {
              registers_tested = 0;
            }
          });
        });
      } catch (error) {
        console.log(error);
      }
      // Note Macchina
      try {
        this.setMachineNotes();
      } catch (error) {
        console.log(error);
      }
      const that = this;
      const request = {
        controller: "quickconnext",
        endpoint: "connext",
        response: { parse: false },
        body: {
          action: "setmachineconfiguration",
          token: localStorage.user_token,
          conf_4_0: btoa(
            unescape(
              encodeURIComponent(
                JSON.stringify(this.machine_configuration.interfaces)
              )
            )
          ),
          id_gateway: this.machine_configuration.gateway_id,
          debug: this.machine_configuration.debug,
          machine_id: this.id_macchina,
          connection_tested_4_0: connection_tested,
          registers_tested_4_0: registers_tested,
        },
        method: "PUT",
        on: {
          load: function () {
            that.ui.snackbar = true;
          },
        },
      };
      this.NETWORK.AjaxRequest(request);
    },
    setMachineNotes() {
      const that = this;
      const request = {
        controller: "quickconnext",
        endpoint: "connext",
        response: { parse: false },
        body: {
          action: "setmachinenotes",
          token: localStorage.user_token,
          id_macchina: this.id_macchina,
          notes: this.machine_notes
        },
        method: "PUT",
        on: {
          load: function () {
            that.ui.snackbar = true;
          },
        },
      };
      this.NETWORK.AjaxRequest(request);
    },
    //#endregion

    //#region Dialog
    openPingDialog() {
      this.$refs.ping_dialog.mostra = true;
      this.$refs.ping_dialog.id_dispositivo =
        this.machine_configuration.gateway_id;
    },

    openDialogTestRegistriMacchina(interf) {
      let modulo = this.schema.modules.filter(
        (f) => f.id_modulo == interf.module_id
      );
      modulo[0].interface_id = interf.interface_id;
      modulo.id_dispositivo = this.machine_configuration.gateway_id;
      modulo.machine_id = this.id_macchina;
      this.$refs.test_registri_dialog.schema = modulo;
      this.$refs.test_registri_dialog.mostra = true;
    },

    openDialogStrumentiDiagnostica(interf) {
      let modulo = this.schema.modules.filter(
        (f) => f.id_modulo == interf.module_id
      );
      this.$refs.strumenti_diagnostica_dialog.mostra = true;
      this.$refs.strumenti_diagnostica_dialog.id_dispositivo =
        this.machine_configuration.gateway_id;
      this.$refs.strumenti_diagnostica_dialog.id_macchina = parseInt(
        this.id_macchina
      );
      this.$refs.strumenti_diagnostica_dialog.id_interfaccia =
        interf.interface_id;
      this.$refs.strumenti_diagnostica_dialog.strumenti_diagnostica =
        modulo[0].diagnostic_functions;
    },
    //#endregion
  },
};
</script>
